export class IncNavigation {
    public static cssClass: string = 'agency-header';

    constructor(private rootElement: HTMLDivElement) {
        this.showAP(false);
    }

    private showAP = (ap: boolean, hasHeader?: boolean): void => {
        const primaryNavDiv = document.querySelector('.primary-header') as HTMLDivElement;
        const primaryMblNavDiv = document.querySelector('.primary-mobile-header') as HTMLDivElement;
        const primaryDrawer = document.querySelector('.primary-drawer') as HTMLElement;
        const primaryDrawerScrim = document.querySelector('#primary-scrim') as HTMLElement;

        if (primaryDrawer) primaryDrawer.hidden = false;
        if (primaryNavDiv) primaryNavDiv.hidden = false;
        if (primaryMblNavDiv) primaryMblNavDiv.hidden = false;
        if (primaryDrawerScrim) primaryDrawerScrim.classList.add('mdc-drawer-scrim');
        // REMOVED: this.configurePrimaryDrawer(); 
        // (No longer in use)
    //    const searchMenuPHMobile = document.getElementsByClassName('searchMenuPHMobile')[0]?.parentElement;
    //    if (searchMenuPHMobile) searchMenuPHMobile.style.display = "block";
    }

    //private setNavBackground = (): void => {
    //    const navbar = this.rootElement.querySelector('.agency-header #agency-navbar') as HTMLDivElement;
    //    if (navbar) {
    //        navbar.style.background = "#f9e7d9";
    //        navbar.style.boxShadow = "0px 0px 0px transparent";
    //    }
    //}

    //private configurePrimaryDrawer = (): void => {
    //    const drawerEl = document.querySelector(".mdc-drawer.primary-drawer") as HTMLElement;
    //    if (drawerEl) {
    //        // Attach the MDCDrawer instance safely
    //        const drawer = (window as any).mdc?.drawer?.MDCDrawer
    //            ? (window as any).mdc.drawer.MDCDrawer.attachTo(drawerEl)
    //            : null;
    //        const topAppBarEl = document.querySelector(".mdc-top-app-bar#primary-navbar") as HTMLElement;
    //        const topAppBar = (window as any).mdc?.topAppBar?.MDCTopAppBar
    //            ? (window as any).mdc.topAppBar.MDCTopAppBar.attachTo(topAppBarEl)
    //            : null;
    //        if (topAppBar && document.querySelector(".main-content")) {
    //            topAppBar.setScrollTarget(document.querySelector(".main-content"));
    //            topAppBar.listen("MDCTopAppBar:nav", () => {
    //                if (drawer) {
    //                    drawer.open = !drawer.open;
    //                }
    //            });
    //        }
    //    }
    //};
}
